import React from 'react';
import { AtlassianIcon, AtlassianLogo } from '@atlaskit/logo';
import { AtlassianNavigation, ProductHome } from '@atlaskit/atlassian-navigation';
import { B400, B200 } from '@atlaskit/theme/colors';
// @ts-ignore:next-line
import underMaintenanceSvg from './under-maintenance.svg';
import './under-maintenance-page.scss';

const Logo = () => <AtlassianLogo textColor={B400} iconColor={B200} />;

const AtlassianProductHome = () => <ProductHome icon={AtlassianIcon} logo={Logo} />;

export const UnderMaintenancePage = ({ appName }: { appName: string }) => {
  return (
    <div className="under-maintenance-page">
      <AtlassianNavigation
        label="site"
        renderProductHome={AtlassianProductHome}
        primaryItems={[]}
        testId="under-maintenance-navigation" // Note: testId is leveraged in CSS
      />
      <div className="under-maintenance-page-body">
        {/* @ts-ignore:next-line */}
        <img src={underMaintenanceSvg} />
        <h1>Under maintenance</h1>
        <p>Sorry, {appName} is currently not available</p>
      </div>
    </div>
  );
};
